import { render, staticRenderFns } from "./OcorrenciaEsfinge.vue?vue&type=template&id=b592eb5e&scoped=true"
import script from "./OcorrenciaEsfinge.vue?vue&type=script&lang=js"
export * from "./OcorrenciaEsfinge.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciaEsfinge.vue?vue&type=style&index=0&id=b592eb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b592eb5e",
  null
  
)

export default component.exports